import React from "react"
import {DatePicker} from "antd"

export function BaseDatePicker(props) {
    const {onChange, ...rest} = props

    return <DatePicker onChange={onChange} {...rest} />
}
